(function () {
    'use strict';

    angular.module("imApp").factory("pictureBanksService", ['$ihttp', function ($ihttp) {
        let service = {
            getPictureBanks: function (parms) {
                return $ihttp.post({
                    method: 2493,
                    parameters: parms || {}
                });
            },
            savePictures: function (parms) {
                return $ihttp.post({
                    method: 2529,
                    parameters: parms || {}
                });
            },
            listPictures: function (parms) {
                return $ihttp.post({
                    method: 2531,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
